import HrBulkCreateTermsForm from 'components/forms/hr/HrBulkCreateTermsForm';

/** Route entry for bulk HR-term creation. */
export default function HrBulkCreateTermsPage() {
  return <HrBulkCreateTermsForm />;
}
